import type { QueryClient } from "@tanstack/react-query";

/** Query key root of the Papierkorb page and the sidebar count. */
export const guestTrashKey = (eventId: string) => ["guestTrash", eventId] as const;

/**
 * After a restore or a purge: the guest list and the requests page have rows
 * to (re)gain, the trash page and the sidebar count have rows to lose. The
 * `importGuestsCompleted` event is how the mounted guest table re-reads its
 * total (the bulk lanes fire the same one).
 */
export function invalidateAfterGuestTrashChange(queryClient: QueryClient, eventId: string): void {
  void queryClient.invalidateQueries({ queryKey: guestTrashKey(eventId) });
  void queryClient.invalidateQueries({ queryKey: ["guestlist", eventId] });
  void queryClient.invalidateQueries({ queryKey: ["guestsRequests", eventId] });
  window.dispatchEvent(new CustomEvent("importGuestsCompleted", { detail: { eventId } }));
}
